import { Tooltip, Icon, Stack } from '@hotjar/hotsauce';
import { PlanTrafficCoverageLabel } from '@hotjar/webapp/features/Billing/Upsell/components/PlanTrafficCoverageLabel/PlanTrafficCoverageLabel';
import { useTranslationWithPrefix } from '@hotjar/translations';

import { AllowanceStyles as S } from '../styles';

export const AskAllowance = ({
  withSkuDropdown,
  allowances,
  isRecommendedPlan,
}: {
  withSkuDropdown?: boolean;
  isRecommendedPlan: boolean;
  allowances: number;
}): JSX.Element | null => {
  const { t } = useTranslationWithPrefix('billing:plan-select-upsell-modal.plan-select');

  return (
    <Stack direction="column" spacing="x1">
      {!withSkuDropdown && (
        <S.FixedHeightAllowanceText>
          {t('allowances.monthly-responses', {
            allowances,
          })}
        </S.FixedHeightAllowanceText>
      )}

      {isRecommendedPlan ? (
        <S.PlanTrafficCoverageWrapper withSkuDropdown={withSkuDropdown}>
          <PlanTrafficCoverageLabel
            coveragePercentage={100}
            maxTrafficCoverageLabel={t('allowances.maximum-responses-coverage-label')}
          />
          <Tooltip text={t('allowances.maximum-responses-coverage-tooltip')} hideOnClick={false}>
            <Icon inline color="text_default" icon="info" size="m" css={{ marginLeft: '5px' }} />
          </Tooltip>
        </S.PlanTrafficCoverageWrapper>
      ) : (
        <S.FixedHeightCoverageWrapper>&nbsp;</S.FixedHeightCoverageWrapper>
      )}
    </Stack>
  );
};
